import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

const useContractSectionService = () => {
    const { doGet, doPost } = useFetch();

    const [fetchingAll, setFetchingAll] = useState(false);
    const [fetchingStore, setFetchingStore] = useState(false);
    const [fetchingEdit, setFetchingEdit] = useState(false);
    const [fetchingUpdate, setFetchingUpdate] = useState(false);
    const [fetchingDelete, setFetchingDelete] = useState(false);

    /**
     * Obtener todas las secciones de un tipo de contrato
     */
    const getAllSections = (contractTypeId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types/${contractTypeId}/sections`),
            setFetching: setFetchingAll
        });
    };

    /**
     * Crear nueva sección
     */
    const storeSection = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('app/contract-drafting/admin/sections/store'),
            body: data,
            setFetching: setFetchingStore
        });
    };

    /**
     * Obtener sección para editar
     */
    const editSection = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/sections/${id}/edit`),
            setFetching: setFetchingEdit
        });
    };

    /**
     * Actualizar sección
     */
    const updateSection = (id: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/sections/${id}/update`),
            body: data,
            setFetching: setFetchingUpdate
        });
    };

    /**
     * Eliminar sección
     */
    const deleteSection = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/sections/${id}/delete`),
            setFetching: setFetchingDelete
        });
    };

    return {
        getAllSections,
        storeSection,
        editSection,
        updateSection,
        deleteSection,
        fetchingAll,
        fetchingStore,
        fetchingEdit,
        fetchingUpdate,
        fetchingDelete,
    };
};

export default useContractSectionService;

